<template>
    <div class="filter-events">
        <BaseFilterSelect
            v-if="showTopic"
            id="topic"
            v-model="selectedTopic"
            :options="availableTopics"
            :track-by-property="'slug'"
            placeholder="Topic"
            @update:model-value="updateTopic($event)"
        />
        <BaseFilterSelect
            v-if="showType"
            id="type"
            v-model="selectedType"
            :options="availableTypes"
            :track-by-property="'slug'"
            placeholder="Type"
            @update:model-value="updateType($event)"
        />
        <BaseToggleButtons
            v-if="showLocation"
            v-model="location"
            :items="locations"
        />
    </div>
</template>

<script setup>
import topicsAndTypesQuery from '~/graphql/queries/filters/topicsAndTypes.graphql';

const props = defineProps({
    modelValue: { // v-model binding!
        type: Object,
        required: true,
        default: () => {
            return {
                topic: null,
                type: null,
                location: null
            };
        }
    },
    categoryType: {
        type: String,
        default: ''
    },
    showLocation: {
        type: Boolean,
        default: false
    },
    showTopic: {
        type: Boolean,
        default: true
    },
    showType: {
        type: Boolean,
        default: true
    }
});

const { categoryType, showTopic, showType } = toRefs(props);

const emit = defineEmits(['input']);

const route = useRoute();
const router = useRouter();

const topic = ref(route.query.topic);
const type = ref(route.query.type);
const location = ref(route.query.location);

const { variables: defaultVariables }  = useCraftVariables();

const variables = computed(() => {
    return {
        ...toValue(defaultVariables),
        group: categoryType.value,
        uri: null
    };
});

const locations = [
    { title: 'Online', slug: 'online' },
    { title: 'In-person', slug: 'in-person' }
];

const { data } = await useAsyncQuery({
    query: topicsAndTypesQuery,
    variables
});

const getArray = (value) => value && Array.isArray(value) ? value : [];

const availableTopics = computed(() => [
    { title: 'All topics', slug: null },
    ...getArray(toValue(data)?.topics)
]);

const availableTypes = computed(() => [
    { title: 'All types', slug: null },
    ...getArray(toValue(data)?.categories)
]);

const selectedTopic = computed(() =>
    getArray(toValue(availableTopics))?.find(item => item.slug === topic.value)
);

const selectedType = computed(() =>
    getArray(toValue(availableTypes))?.find(item => item.slug === type.value)
);

const updateTopic = (topicSlug) => {
    topic.value = topicSlug;
};

const updateType = (typeSlug) => {
    type.value = typeSlug;
};

const updateRouteQueryParams = (values) => {
    const query = {
        ...route.query,
        page: 1, // assume query param for paginator on this page is "page"
        ...values
    };
    router.replace({ query });
};

watch(topic, () => {
    const newValue = { ...props.modelValue, topic: toValue(topic) };
    emit('input', newValue);
    updateRouteQueryParams(newValue);
});

watch(type, () => {
    const newValue = { ...props.modelValue, type: toValue(type) };
    emit('input', newValue);
    updateRouteQueryParams(newValue);
});

watch(location, () => {
    const newValue = { ...props.modelValue, location: location.value };
    emit('input', newValue);
    updateRouteQueryParams(newValue);
});
</script>

<style lang="less" src="./filter-events.less"></style>

